import { fetchRequest } from 'src/hooks/useAPIRequest'
import { API_ENDPOINTS } from 'src/routes/routes'

interface SSOSettings {
    enabled: boolean
    redirectAfterLogin: boolean
    clientIds: string[]
    redirectAfterLoginUrl: string
}

interface BrandingSettings {
    logoUrl: string
}

interface StylingSettings {
    mainColor: string
}

interface PurchaseNoticeSettings {
    costAmount: number
    proofOfOwnership: boolean
}

interface BidsSettings {
    visualisation: 'list' | 'amount'
    visualisationOptions: {
        list: {
            fixedAmount: number
            hideDealer: boolean
            roundOn100: boolean
            displayThreshold: number
        }
        amount: {
            fixedAmount: number
            percentage: number
            xBids: number
        }
    }
}

interface IntegrationSettings {
    [key: string]: {
        token: string
    }
}

export enum InterventionCost {
    READ_ONLY = 'read_only',
    ONLY_POSITIVE = 'only_positive',
    POSITIVE_AND_NEGATIVE = 'positive_and_negative',
}

export enum MarginTransfer {
    READ_ONLY = 'read_only',
    EDITABLE = 'editable',
}

interface ProposalSettings {
    interventionCost: InterventionCost
    marginTransfer: MarginTransfer
}

interface PriceRequestSettings {
    visibleInOverview: boolean
    visibleToSellerOnlyAfterListStop: boolean
}
interface TradeInSettings {
    allowDispatch?: boolean
}

interface DigexBuilder {
    name: string
    url: string
}

interface ExternalLinksSettings {
    digexBuilders?: DigexBuilder[]
}

export type AfterSalesProgram = 'wecare'

export type FooterItemType = 'link' | 'phone' | 'whatsapp' | 'email'

export interface FooterItem {
    type: FooterItemType
    linkText: string
    url: string
    label?: string
    tooltip?: string
}

interface AfterSalesSettings {
    programs?: AfterSalesProgram[]
}

export interface AppSettings {
    grafanaOrgId?: string
    sso: SSOSettings
    branding: BrandingSettings
    styling: StylingSettings
    vatRate: number
    purchaseNotice: PurchaseNoticeSettings
    bids: BidsSettings
    vinSearchProviders: string[]
    dmsType: string
    integrations: IntegrationSettings
    options: {
        custom: boolean
        unique: boolean
    }
    modules: string[]
    proposal: ProposalSettings
    priceRequest: PriceRequestSettings
    tradeIn?: TradeInSettings
    valuationProviders?: string[]
    externalLinks?: ExternalLinksSettings
    afterSales?: AfterSalesSettings
    footerItems?: FooterItem[]
}

const getAppSettings = async () => {
    return await fetchRequest<AppSettings>(API_ENDPOINTS.APP_SETTINGS)
}

export default getAppSettings
